import { useMemo } from 'react'

import { cap } from '../../../State'
import { translations } from '../../../translations'
import { formatSeconds } from './utils'

const language = cap.language.state || 'IT'
const t = translations[language]

/**
 * Grafico a barre orizzontali CSS che mostra il tempo medio di esecuzione per unit (top 25).
 * @param {{ processStepsStats: Array<{ unit: string, executionTime: number }> }} props
 * @returns {JSX.Element|null}
 */
export const UnitAvgBarChart = ({ processStepsStats = [] }) => {
  const sortedData = useMemo(
    () => [...processStepsStats].sort((a, b) => b.executionTime - a.executionTime).slice(0, 25),
    [processStepsStats]
  )

  if (!processStepsStats.length) return null

  const maxTime = sortedData[0]?.executionTime || 1

  return (
    <div className="ncard" style={{ marginBottom: 18 }}>
      <div className="ncard__head">
        <div className="ncard__ico">
          <i className="pi pi-chart-bar" style={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="ncard__title">{t.pfTempoMedioPerUnit}</h3>
          <div className="ncard__sub">
            {t.pfSecondiTop} {sortedData.length} {t.pfOrdinateDecrescente}
          </div>
        </div>
      </div>
      <div className="ncard__body">
        {sortedData.map((u) => (
          <div
            key={u.unit}
            style={{
              display: 'grid',
              gridTemplateColumns: '220px 1fr 64px',
              gap: 14,
              alignItems: 'center',
              padding: '7px 0',
              borderBottom: '1px solid var(--border)',
              transition: 'background 0.15s'
            }}
          >
            <span
              style={{
                fontFamily: 'var(--font-mono)',
                fontSize: 12,
                color: 'var(--ink-700)',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              {u.unit}
            </span>
            <div
              style={{
                height: 10,
                background: 'var(--surface-3)',
                borderRadius: 999,
                overflow: 'hidden'
              }}
            >
              <div
                style={{
                  height: '100%',
                  width: `${(u.executionTime / maxTime) * 100}%`,
                  background: 'linear-gradient(90deg, var(--primary), var(--primary-600))',
                  borderRadius: 999,
                  transition: 'width 0.6s ease-out'
                }}
              />
            </div>
            <span
              style={{
                fontFamily: 'var(--font-mono)',
                fontSize: 12,
                fontWeight: 600,
                color: 'var(--ink-900)',
                textAlign: 'right'
              }}
            >
              {formatSeconds(u.executionTime, true)}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
